//获取url参数
const navList = [
    {
        name:"类别",
        type:1
    },
    {
        name:"出处",
        type:2
    },
    {
        name:"年代",
        type:3
    }
]
 


const seachOption = [
  {
    type:1,
    name:"全字段"
  },
  {
    type:2,
    name:"册名"
  },
  {
    type:3,
    name:"篇名"
  },
  {
    type:4,
    name:"著译者"
  },
  {
    type:5,
    name:"出处"
  }
]
  module.exports = {
    navList: navList , 
    seachOption : seachOption
  };